import styled from 'styled-components'
import { COLORS, SPACING, TYPOGRAPHY, TRANSITIONS, FONT_WEIGHT } from '../../../styles/theme'

export const FlowContainer = styled.div`
  width: 100%;
`

export const ProgressContainer = styled.div`
  margin-bottom: ${SPACING.xl};
`

export const ProgressBar = styled.div`
  height: 4px;
  background: ${COLORS.borderLight};
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: ${SPACING.sm};
`

export const ProgressFill = styled.div<{ $progress: number }>`
  height: 100%;
  background: ${COLORS.primary};
  border-radius: 2px;
  width: ${(props) => props.$progress}%;
  transition: width 0.3s ease;
`

export const StepIndicator = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: ${COLORS.textSecondary};
  text-align: center;
`

export const QuestionTitle = styled.h3`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: ${COLORS.textPrimary};
  margin: 0 0 ${SPACING.xl} 0;
  text-align: center;
`

export const StepContent = styled.div`
  animation: slideIn 0.22s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(28px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`

export const NavigationButtons = styled.div`
  display: flex;
  gap: ${SPACING.md};
  margin-top: ${SPACING.xl};
`

export const BackButton = styled.button`
  flex: 1;
  padding: ${SPACING.md} ${SPACING.lg};
  border: 1px solid ${COLORS.borderDarkVar};
  border-radius: 6px;
  background: ${COLORS.bgPrimary};
  color: ${COLORS.textSecondary};
  font-size: ${TYPOGRAPHY.body.fontSize};
  cursor: pointer;
  transition: ${TRANSITIONS.all};

  &:hover {
    border-color: ${COLORS.primary};
    background: ${COLORS.bgHover};
    color: ${COLORS.textPrimary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ContinueButton = styled.button<{ $disabled?: boolean }>`
  flex: 2;
  padding: ${SPACING.md} ${SPACING.lg};
  border: none;
  border-radius: 6px;
  background: ${(props) => (props.$disabled ? COLORS.borderDarkVar : COLORS.primary)};
  color: white;
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  transition: ${TRANSITIONS.all};

  &:hover:not(:disabled) {
    background: var(--color-primary-hover);
  }

  &:disabled {
    background: ${COLORS.borderDarkVar};
    cursor: not-allowed;
  }
`

export const OtherInput = styled.input`
  width: 100%;
  padding: ${SPACING.md};
  border: 1px solid ${COLORS.borderDarkVar};
  border-radius: 6px;
  font-size: ${TYPOGRAPHY.body.fontSize};
  margin-top: ${SPACING.sm};
  transition: ${TRANSITIONS.all};
  background: ${COLORS.bgInput};
  color: ${COLORS.textPrimary};

  &:focus {
    outline: none;
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 2px ${COLORS.focusRing};
  }

  &::placeholder {
    color: ${COLORS.textPlaceholder};
  }
`
